import * as React from 'react';
import { Card } from 'antd';

const ComponentLoader = () =>  {
    return (<Card loading={true} title={'Loading component'} />);
}

export default ComponentLoader;